<template>
    <div>
        <div class="update">
            <p class="update__datetime">
                <span class="update__time">{{ timeString }}</span> <span class="update__date">{{ dayString }} </span>
            </p>

            <p class="update__title">
                {{ update.title }}
            </p>

            <p class="update__body">
                <div v-html="update.body" class=""></div>
            </p>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';
    import { SERVER_DATE_FORMAT, SERVER_TIME_FORMAT, LOCAL_TIME_FORMAT } from "@/constants.js";

    export default {
        props: ['update'],

        computed: {
            dayString() {
                return moment(this.update.created_at, SERVER_DATE_FORMAT).format("DD/MM/YY");
            },

            timeString() {
                return moment(this.update.created_at, SERVER_TIME_FORMAT).format(LOCAL_TIME_FORMAT)
            },
        }
    }
</script>

<style scoped lang="scss">

    .update {

        &--purple &__datetime {
            color: $color-purple;
        }

        &--purple &__date {
            display: block;
            padding-top: 0.5rem;
        }

        &--purple {
            border-bottom: 1px solid $color-purple;
            margin-bottom: 1rem;
        }

        //border-top: 1px dashed #e6e6e6;
        //padding-top: 1rem;

        p {
            margin-bottom: 0;
            line-height: 1;
        }

        &__datetime {
            @include font-h3;
            font-weight: 200;
            color: $color-light-blue;
            margin-top: 0.5rem;
            margin-bottom: 0.5rem;
        }

        &__time {
            margin-right: 1rem;
        }

        &__title{
            margin-top: 0.5rem;
            font-weight: 500;
            @include font-h3;
        }
        &__body {
            font-weight: 200;
        }
    }
</style>